import { IconButton, Typography } from "@mui/material";

import { initializeEncryption } from "../../services/AesGcmEncryption";
import * as CONSTANT from "../../constants/Constant";

import { Box, useTheme } from "@mui/material";
import Stack from "@mui/material/Stack";
import { tokens } from "../../theme";
import CustomButton from "../../components/CustomButton";
import Grid from "@mui/material/Unstable_Grid2";
import HighlightStats from "../../components/HighlightStats";
import * as React from "react";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import ConnectionStatus from "../../utils/ConnectionStatus";
import { SnackbarProvider, useSnackbar } from "notistack";
import UseOnlineStatus from "../../utils/UseOnlineStatus";
import {
  getFromLocalStorage,
  getFromLocalStorageJsonObject,
  saveToLocalStorageJsonObject,
} from "../../utils/localStorageUtils";
import CustomProgressDialog from "../../components/CustomProgressDialog";
import ShowErrorAlertDialog from "../../components/ErrorAlertDialog";
import { useAtom } from "jotai";
import {
  isAuthPageAtom,
  showErrorAlertDialog,
} from "../../config/AppConfig";
import { getButtonVisibilityData } from "../../utils/GetButtonVisibilityAsPerLoginResponse";

import {
  ALERT,
  ERROR_WHILE_FETCHING_DATA,
  LOADING_PLEASE_WAIT,
  NO_INTERNET_CONNECTION_FOUND,
  YOU_ARE_OFFLINE,
  YOU_ARE_ONLINE,
  FETCHING_ON_HOLD_SUMMARY_PLEASE_WAIT,
  ERROR,
  PROCESSING_PLEASE_WAIT,
} from "../../constants/Strings";
import DebugLog from "../../utils/DebugLog";
import {
  LOGIN_ID,
  MESSAGE_KEY,
  SESSION_ID,
  USER_ROLE,
  USER_NAME,
  SELECTED_ON_HOLD_CYCLE,
} from "../../constants/LocalStorageKeyValuePairString";
import {
  generateRandomId,
  generateRequestId,
} from "../../utils/RequestIdGenerator";
import { saveAs } from "file-saver";

import {
  getOnHoldHeaderSummary,
  
  cancelOnHoldTransactionType,
  requestReleaseOnHoldTransactionType,
  releaseOnHoldTransactionType,
  downloadOnHoldReports,
} from "../../services/ApiService";
import { useNavigate, useLocation } from "react-router-dom";
import {
  onHoldPayoutCycleColumnHeader,
} from "../../components/ColumnHeader";
import NoDataFound from "../../components/NoDataFound";
import { ApiErrorCode, ApiType } from "../../services/ApiTags";
import { formatPrice } from "../../utils/PriceFormatter";
import DownloadDropdownButton from "../../components/DownloadDropdownButton";
import { IncentivesActionsConfirmationDialog } from "../../components/IncentivesActionsConfirmationDialog";
import useAxiosHookV2 from "../../hooks/UseAxiosV2";
import useAxiosHookV2FileUpload from "../../hooks/UseAxiosV2FileUpload";

// Filter Configurations to be passed to SearchBarFilter in SectionHeader
const filterProps = [
  {
      keyValue: 'Transaction Type',
      displayName: 'Name',
      paramName: 'type',
      isDateFilter: false,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
      keyValue: 'Report Date',
      displayName: 'Report',
      paramName: 'reportDate',
      isDateFilter: true,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
      keyValue: 'Cut Off Date',
      displayName: 'Cut Off',
      paramName: 'cutoffDate',
      isDateFilter: true,
      isSearchBarDropdown: false,
      searchBarDropdownOptions: [],
  },
  {
    keyValue: 'Payout Date',
    displayName: 'Payout By',
    paramName: 'payoutDate',
    isDateFilter: true,
    isSearchBarDropdown: false,
    searchBarDropdownOptions: [],
  },
];


export function OnHoldDetails() {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const navigate = useNavigate();
  const location = useLocation();
  let selectedOnHoldCycle = location.state;

  const navData = location.state && location.state.data;

  const isNetworkConnectionAvailable = UseOnlineStatus();
  const [userRole, setUserRole] = useState([]);

  const [, setAuthStatus] = useAtom(isAuthPageAtom);
  const [getDialogStatus, setErrorDialog] = useAtom(showErrorAlertDialog);
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState(ALERT);
  const [content, setContent] = useState("");
  const [, setError] = useState("");
  const [getProgressbarText, setProgressbarText] = useState("");

  const [payoutCycleName, setPayoutCycleName] = useState("");
  const [onHoldHeaderSummary, setOnHoldHeaderSummary] = useState([]);
  const [onHoldSummary, setOnHoldSummary] = useState([]);

  const [gridHeight, setGridHeight] = useState(108); // Default height
  const [rowsPerPage, setRowsPerPage] = useState(0); // Used to set the height of the grid

  // pagination
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 15,
    page: 0,
  });
  const [pageSize, setPageSize] = useState(15);
  const [totalNoOfRows, setTotalNoOfRows] = useState(0);
  const [totalNoOfPages, setTotalNoOfPages] = useState(0);

  const [selectedRows, setSelectedRows] = React.useState([]);

  const [requestReleaseButtonVisible, setRequestReleaseButton] =
    useState(false);
  
  const [downloadButtonVisible, setDownlaodButton] = useState(false);
  const [releaseButtonVisibility, setReleaseButton] = useState(false);
  const [cancelButtonButtonVisibility, setCancelButton] = useState(false);
  const [commentButtonVisibility, setComment] = useState(false);
  const [rejectButtonVisibility, setRejectButton] = useState(false);

  const [dialogOpen, setDialogOpen] = useState(false);
  const [clickedButtonType, setClickedButtonType] = useState("");
  const [dialogTitle, setDialogTitle] = useState("");
  const [batchNo, setBatchNo] = useState("");
  const [holdType, setHoldType] = useState("");
  const { data, apiCallError, showProgressBar, fetchData } = useAxiosHookV2();

  // filter and search
  const [selectedFilter, setSelectedFilter] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const {
    dataResponseFileUpload,
    apiCallErrorFileUpload,
    showProgressBarFileUpload,
    fetchDataFileUpload,
  } = useAxiosHookV2FileUpload();
 

  // sort model
  const [sortModel, setSortModel] = useState([]);
 
  useEffect(() => {
    getUserRole();
    checkSelectedOnHoldCycle();
    updateButtonVisibility();
  }, []);

  useEffect(() => {

    setBatchNo(selectedOnHoldCycle?.batchNo)
    setHoldType(selectedOnHoldCycle?.holdType)
    setPayoutCycleName(selectedOnHoldCycle?.commissionType);

    
    
    getHeaderSummary(
      selectedOnHoldCycle?.batchNo,
      selectedOnHoldCycle?.commissionType
    );

    getOnHoldTransactionType(
      selectedOnHoldCycle?.companyCode,
      selectedOnHoldCycle?.holdType,
      selectedOnHoldCycle?.batchNo,
      selectedOnHoldCycle?.commissionType,
      paginationModel.page,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, []);

  // sorting handling 
  useEffect(() => {
    checkSelectedOnHoldCycle();

    getOnHoldTransactionType(
      selectedOnHoldCycle?.companyCode,
      selectedOnHoldCycle?.holdType,
      selectedOnHoldCycle?.batchNo,
      selectedOnHoldCycle?.commissionType,
      paginationModel.page,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  }, [sortModel]);

  useEffect(() => {
    getDataGridHeight();
    // requestOnHoldDetails();

    showNoInternetSnackBar();

    navigate(blockNavigation);
  }, [isNetworkConnectionAvailable, enqueueSnackbar, navigate, rowsPerPage]);

  const handleDialogOpen = (type) => {
    let title = "";
    if (type === "Cancel") {
      title = "Cancel";
    } else if (type === "Reject") {
        title = "Reject";
      } else if (type === "Release") {
      title = "Release";
    } else if (type === "Request Release") {
      title = "Request Release";
    }
    setClickedButtonType(type);
    setDialogTitle(title);
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };
  useEffect(() => {
    if (showProgressBar) {
      setProgressbarText(PROCESSING_PLEASE_WAIT);
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [showProgressBar]);

  // useEffect(() => {
  //   DebugLog("RESPONSE FROM API:"+JSON.stringify(data))
  // }, [data]);

  useEffect(() => {
    if (apiCallError) {
      if (
        apiCallError.data != null &&
        apiCallError.data.responseCode != null &&
        apiCallError.data.responseCode != "-1"
      ) {
        const message =
          apiCallError.response != null
            ? apiCallError.response
            : apiCallError.message;
        showErrorAlert(
          apiCallError.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      } else {
        const message =
          apiCallError.data != null
            ? apiCallError.data.displayErrorMessage
            : apiCallError.message;
        showErrorAlert(
          ERROR,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    }
  }, [apiCallError]);
  const handleSubmit = (file, comment, type , date) => {
    

    let formattedDate = date
    if(type==="Cancel"){
       formattedDate = null
    }
  
    dialogResponseRecieved(file, comment, type,formattedDate);
  };

  const dialogResponseRecieved = (file, comment, type,date) => {
    const selectedData = onHoldSummary.filter((row) =>
      selectedRows.includes(row.id)
    );

    if (selectedData.length > 0) {
      const extractBatchNo = selectedData[0].batchNo;
      const extractVersionCode = selectedData[0].version;

      const transactionTypes = selectedData.map((item) => item.transactionType);

      if (file) {
        const fileNameWithoutExtension = file.name
          .split(".")
          .slice(0, -1)
          .join(".");

        handleFileChange(
          file,
          extractBatchNo,
          fileNameWithoutExtension,
          comment,
          extractVersionCode,
          transactionTypes,
          type,
          date
        );
        return;
      } else {
        
        const requestData = {
          holdType: holdType,
          batchNo: extractBatchNo,
          remark: comment,
          version: extractVersionCode,
          transactionTypes: transactionTypes,
          selectedDate:date
        };

        if (type === "Cancel") {
          requestOnHoldCancel(requestData,"");
        } else if (type === "Release") {
          releaseOnHoldApiRequest(requestData,"");
        } else if (type === "Request Release") {
          requestReleaseOnHoldApiCall(requestData,"");
        } else if (type === "Reject") {
        rejectOnHoldApiRequest(requestData, "");
      }
        DebugLog("onHold Request Data =======" + JSON.stringify(requestData));
      }
    } else {
      showErrorAlert("Alert", "Please choose some rows first!");
    }
  };

  const handleFileChange = async (
    selectedFile,
    extractBatchNo,
    fileNameWithoutExtension,
    comment,
    extractVersionCode,
    transactionTypes,
    type,
    date
  ) => {
    try {
      const fileBase64Encoding = await getBase64(selectedFile);
       // Extract only the Base64 data
       const base64Only = fileBase64Encoding.split(',')[1];
      //const fileByteArray = await getByteArray(selectedFile);
      const requestData = {
        holdType: holdType,
        batchNo: extractBatchNo,
        fileName: fileNameWithoutExtension,
        fileType: selectedFile.type,
        //contentBase64: "",
        remark: comment,
        version: extractVersionCode,
        transactionTypes: transactionTypes,
        selectedDate:date
      };
      DebugLog(
        "onHold Request Data base64 =======" + JSON.stringify(requestData)
      );

      if (type === "Cancel") {
        requestOnHoldCancel(requestData,base64Only);
      } else if (type === "Release") {
        releaseOnHoldApiRequest(requestData,base64Only);
      } else if (type === "Request Release") {
        requestReleaseOnHoldApiCall(requestData,base64Only);
      } else if (type === "Reject") {
        rejectOnHoldApiRequest(requestData,base64Only);
      }

      // return base64String;
    } catch (error) {
      console.error("Error converting file to byte array:", error);
    }
  };
  const getBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  };


  // const requestOnHoldCancelMultipartFormDataApiCall =  (onHoldCancelRequestData,byteArray) => {
  //   try {
  //     if (isNetworkConnectionAvailable) {
  //       setProgressbarText(LOADING_PLEASE_WAIT);
  //       setLoading(true);


  //       initializeEncryption(
  //         onHoldCancelRequestData,
  //         getFromLocalStorage(MESSAGE_KEY),
  //         ApiType.CANCEL_ON_HOLD_COMPANY
  //       ).then((encryptedContentData) => {

  //         const formData = new FormData();
  //         const blob = new Blob([byteArray], { type: onHoldCancelRequestData.fileType });
  //         formData.append('file', blob, onHoldCancelRequestData.fileName);
  //         formData.append('contentData', encryptedContentData); // Append additional parameter
  //         formData.append('sessionId',  getFromLocalStorage(SESSION_ID)); // Append additional parameter
  //         formData.append('requestId',  generateRequestId()); // Append additional parameter
  //         formData.append('loginId',  getFromLocalStorage(LOGIN_ID)); // Append additional parameter
  //         formData.append('loginUserName',  getFromLocalStorage(USER_NAME)); // Append additional parameter


  //         cancelOnHoldTransactionTypeMultipart(formData)
  //           .then((response) => {
  //             if (response.data.responseCode === "0") {
  //               if (response.data.responseCode === "0") {
  //                 navigate("/OnHoldActionItemsSuccess", {
  //                   state: { data: response.data.result, type: 1 },
  //                 });
  //               }
  //             }
  //             resetSelection();
  //             setLoading(false);
  //           })
  //           .catch((error) => {
  //             if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
  //               try {
  //                 navigate("/");
  //               } catch (error) {
  //                 DebugLog("error " + error);
  //               }
  //             } else {
  //               const message =
  //                 error.response != null
  //                   ? error.displayErrorMessage
  //                   : "Unknown";

  //               if (message)
  //                 showErrorAlert(
  //                   error.message,
  //                   ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
  //                 );
  //             }
  //           });
  //       });
  //     } else {
  //       showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
  //     }
  //   } catch (error) {
  //     const message = error.response != null ? error.response : error.message;
  //     showErrorAlert(
  //       error.message,
  //       ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
  //     );
  //   }
  // };

  const rejectOnHoldApiRequest = (onHoldCancelRequestData, fileBase64Encoding) => {
      try {
        if (isNetworkConnectionAvailable) {
          initializeEncryption(
            onHoldCancelRequestData,
            getFromLocalStorage(MESSAGE_KEY),
            ApiType.REJECT_ON_HOLD_TRANSACTION_TYPE
          ).then((encryptedContentData) => {
            let requestData;
            if (fileBase64Encoding !== null && fileBase64Encoding !== "") {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                contentData: encryptedContentData,
                loginUserName: getFromLocalStorage(USER_NAME),
                fileContent: fileBase64Encoding,
              };
            } else {
              requestData = {
                requestId: generateRequestId(),
                loginId: getFromLocalStorage(LOGIN_ID),
                sessionId: getFromLocalStorage(SESSION_ID),
                contentData: encryptedContentData,
                loginUserName: getFromLocalStorage(USER_NAME),
              };
            }
  
            fetchDataFileUpload(
              process.env.REACT_APP_REJECT_ON_HOLD_TRANSACTION_TYPE_API_URL,
              ApiType.REJECT_ON_HOLD_TRANSACTION_TYPE,
              ApiType.POST_METHOD,
              requestData,
              {},
              (data) => {
                if (data !== null) {
                  if (data.responseCode === "0") {
                    navigate("/OnHoldActionItemsSuccess", {
                      state: { data: data.result, type: 3 },
                    });
                  }
                }
              }
            );
          });
        } else {
          showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
        }
      } catch (error) {
        const message = error.response != null ? error.response : error.message;
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
        );
      }
    };

  const releaseOnHoldApiRequest = (onHoldCancelRequestData,fileBase64Encoding) => {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CANCEL_ON_HOLD_COMPANY
        ).then((encryptedContentData) => {
          let requestData
          if(fileBase64Encoding!==null && fileBase64Encoding!==""){
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding
            };
          }else{
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          releaseOnHoldTransactionType(requestData)
            .then((response) => {
              if (response.data.responseCode === "0") {
                if (response.data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: response.data.result, type: 0 },
                  });
                }
              }
              resetSelection();
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response != null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  };


 

  const requestOnHoldCancel =  (onHoldCancelRequestData,fileBase64Encoding) => {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        // const requestObject = {
        //   id: data.id,
        // };

        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CANCEL_ON_HOLD_COMPANY
        ).then((encryptedContentData) => {
          let requestData
          if(fileBase64Encoding!==null && fileBase64Encoding!==""){
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding
            };
          }else{
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          cancelOnHoldTransactionType(requestData)
            .then((response) => {
              if (response.data.responseCode === "0") {
                if (response.data.responseCode === "0") {
                  navigate("/OnHoldActionItemsSuccess", {
                    state: { data: response.data.result, type: 1 },
                  });
                }
              }
              resetSelection();
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response != null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  };

  const requestReleaseOnHoldApiCall = (onHoldCancelRequestData,fileBase64Encoding) => {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        // const requestObject = {
        //   id: data.id,
        // };

        initializeEncryption(
          onHoldCancelRequestData,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CANCEL_ON_HOLD_COMPANY
        ).then((encryptedContentData) => {
          let requestData
          if(fileBase64Encoding!==null && fileBase64Encoding!==""){
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
              fileContent: fileBase64Encoding
            };
          }else{
            requestData = {
              requestId: generateRequestId(),
              loginId: getFromLocalStorage(LOGIN_ID),
              sessionId: getFromLocalStorage(SESSION_ID),
              contentData: encryptedContentData,
              loginUserName: getFromLocalStorage(USER_NAME),
            };
          }

          requestReleaseOnHoldTransactionType(requestData)
            .then((response) => {
              if (response.data.responseCode === "0") {
                navigate("/OnHoldActionItemsSuccess", {
                  state: { data: response.data.result, type: 2 },
                });
              }
              resetSelection();
              setLoading(false);
            })
            .catch((error) => {
              if (error.data.errorCode === ApiErrorCode.SESSION_EXPIRED) {
                navigate(CONSTANT.LOGIN)
              }
             else 
              if (error.data.errorCode === ApiErrorCode.SESSION_ID_NOT_FOUND) {
                try {
                  navigate("/");
                } catch (error) {
                  DebugLog("error " + error);
                }
              } else {
                const message =
                  error.response != null
                    ? error.displayErrorMessage
                    : "Unknown";

                if (message)
                  showErrorAlert(
                    error.message,
                    ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
                  );
              }
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
  };

  
  const updateButtonVisibility = () => {
    const actionButtonList = getButtonVisibilityData("Incentive", "On Hold");
    if (actionButtonList) {
      actionButtonList.forEach((items, index) => {
        // HOLD, DOWNLOAD, APPROVE, VIEW, REQUEST APPROVAL
        if (items.buttonName === "DOWNLOAD") {
          setDownlaodButton(true);
        } else if (items.buttonName === "REQUEST RELEASE") {
          setRequestReleaseButton(true);
        } else if (items.buttonName === "RELEASE") {
          setReleaseButton(true);
        } else if (items.buttonName === "CANCEL") {
          setCancelButton(true);
        } else if (items.buttonName === "REJECT") {
          setRejectButton(true);
        }else if (items.buttonName === "COMMENT") {
          setComment(true);
        }
      });
    }
  };


  function downloadOnHoldDetails(fileType) {
    try {
      if (isNetworkConnectionAvailable) {
        setProgressbarText(LOADING_PLEASE_WAIT);
        setLoading(true);

        const requestObject = {
          // fromDate: params.fromDate,
          // toDate: params.toDate,
          // accountCode: params.code,
          // accountName: params.name,
          // reason: params.reason,

          reportTemplate: "ON_HOLD_REPORT",
          reportFormat: fileType,
          batchId:batchNo,
        };

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.CREDIT_DEBIT_REPORT_DOWNLOAD
        ).then((encryptedContentData) => {
          const requestData = {
            requestId: generateRequestId(),
            loginId: getFromLocalStorage(LOGIN_ID),
            sessionId: getFromLocalStorage(SESSION_ID),
            loginUserName: getFromLocalStorage(USER_NAME),
            contentData: encryptedContentData,
          };

          downloadOnHoldReports(requestData)
            .then((response) => {
              setLoading(false);

              let blob;
              const currentDate = new Date();
              const day = String(currentDate.getDate()).padStart(2, "0");
              const month = String(currentDate.getMonth() + 1).padStart(2, "0");
              const year = String(currentDate.getFullYear());

              // let filename be "EarmarkReport_YYYY-MM-DD"
              let filename = `OnHoldReport_${year}-${month}-${day}`;
              switch (fileType) {
                case "CSV":
                  blob = new Blob([response.data], { type: "text/csv" });
                  filename = filename + ".csv";
                  break;
                case "XLS":
                  blob = new Blob([response.data], {
                    type: "application/vnd.ms-excel",
                  });
                  filename = filename + ".xls";
                  break;
                case "PDF":
                  blob = new Blob([response.data], { type: "application/pdf" });
                  filename = filename + ".pdf";
                  break;

                default:
                  throw new Error("Invalid file type");
              }

              // Use FileSaver to save the file
              saveAs(blob, filename);
            })
            .catch((error) => {
              handleError(error);
            });
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      handleError(error);
    }
  }

  /********  Pagination Methods ***********/
  const handlePageJump = (event) => {
    const newPage = parseInt(event.target.value, 10) - 1;
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedOnHoldCycle();

    getOnHoldTransactionType(
      selectedOnHoldCycle?.companyCode,
      selectedOnHoldCycle?.holdType,
      selectedOnHoldCycle?.batchNo,
      selectedOnHoldCycle?.commissionType,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageChange = (newPage) => {
    setPaginationModel({ pageSize: pageSize, page: newPage });
    checkSelectedOnHoldCycle();

    getOnHoldTransactionType(
      selectedOnHoldCycle?.companyCode,
      selectedOnHoldCycle?.holdType,
      selectedOnHoldCycle?.batchNo,
      selectedOnHoldCycle?.commissionType,
      newPage,
      paginationModel.pageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handlePageSizeChange = (newPageSize) => {
    // keep pageSize in sync with the paginationModel
    setPageSize(newPageSize);
    setPaginationModel({ pageSize: newPageSize, page: 0 });
    checkSelectedOnHoldCycle();

    // call api with new page size and start from page 0.
    getOnHoldTransactionType(
      selectedOnHoldCycle?.companyCode,
      selectedOnHoldCycle?.holdType,
      selectedOnHoldCycle?.batchNo,
      selectedOnHoldCycle?.commissionType,
      0,
      newPageSize,
      selectedFilter,
      searchQuery
    );
  };

  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection);
  };

  const resetSelection = () => {
    setSelectedRows([]);
  };

  function getUserRole() {
    setUserRole(getFromLocalStorage(USER_ROLE));
  }

  // increase - decrease list layout height on available list itmes count
  function getDataGridHeight() {
    // Calculate the total height required for the grid
    const headerHeight = 60; // Height of header row
    const rowHeight = 60; // Height of each data row
    let rowCount = 0;
    if (rowsPerPage <= pageSize) {
      rowCount = rowsPerPage; // Total number of data rows
    } else {
      rowCount = pageSize; // Total number of data rows
    }

    const totalHeight = headerHeight + rowCount * rowHeight;

    // Set the grid height
    setGridHeight(totalHeight);
  }

  function checkSelectedOnHoldCycle() {
    // If selectedPayoutCycle is not in the location state (e.g., after a page refresh),
    // try to retrieve it from localStorage
    if (!selectedOnHoldCycle) {
      const storedData = getFromLocalStorageJsonObject(
        SELECTED_ON_HOLD_CYCLE,
        JSON.stringify(selectedOnHoldCycle)
      );
      selectedOnHoldCycle = storedData ? JSON.parse(storedData) : null;
      DebugLog("selectedOnHoldCycle >>>>"+JSON.stringify(selectedOnHoldCycle))
    } else {
      // If payoutRowSelected is in the location state, store it in localStorage
      saveToLocalStorageJsonObject(
        SELECTED_ON_HOLD_CYCLE,
        JSON.stringify(selectedOnHoldCycle)
      );
    }
  }

  /******* API Calls *********/
  async function getHeaderSummary(receivedBatchNo, receivedCommissionType) {
    try {
      if (!isNetworkConnectionAvailable) {
        throw new Error(NO_INTERNET_CONNECTION_FOUND);
      }
      setProgressbarText(FETCHING_ON_HOLD_SUMMARY_PLEASE_WAIT);
      setLoading(true); // Hide the progress dialog

      const contentData = {
        batchNo: receivedBatchNo,
        commissionType: receivedCommissionType,
      };

      const encryptedContentData = await initializeEncryption(
        contentData,
        getFromLocalStorage(MESSAGE_KEY),
        ApiType.ON_HOLD_HEADER_SUMMARY
      );

      const requestData = {
        requestId: generateRequestId(),
        loginId: getFromLocalStorage(LOGIN_ID),
        sessionId: getFromLocalStorage(SESSION_ID),
        loginUserName: getFromLocalStorage(USER_NAME),
        contentData: encryptedContentData,
      };

      getOnHoldHeaderSummary(requestData)
        .then((response) => {
          DebugLog("onHoldHeaderSummary response: " + JSON.stringify(response));
          setOnHoldHeaderSummary(response.data.result);
          setLoading(false);
        })
        .catch((error) => {
          handleError(error);
        });
    } catch (error) {
      handleError(error);
    }
  }

  async function getOnHoldTransactionType(
    companyCode,
    holdType,
    receivedBatchNo,
    commissionType,
    pageNo,
    pageSize,
    selectedFilter,
    filterValue
  ) {

    try {
      if (isNetworkConnectionAvailable) {
      //   const requestObject = {
      //   companyCode:companyCode,
      //   holdType:holdType,
      //   batchNo: receivedBatchNo,
      //  // commissionType: commissionType,
      //   pageNumber: pageNo,
      //   pageSize: pageSize,
      //   };

        const requestObject = createRequestObject(
          holdType,
          companyCode,
          receivedBatchNo,
          pageNo,
          pageSize,
          selectedFilter,
          filterValue
        );

        initializeEncryption(
          requestObject,
          getFromLocalStorage(MESSAGE_KEY),
          ApiType.HOLD_PAYOUT_TRANSACTION_TYPE
        ).then((encryptedContentData) => {
          fetchData(
            process.env.REACT_APP_ON_HOLD_PAYOUT_SUMMARY_TRANS_TYPE_API_URL,
            ApiType.HOLD_PAYOUT_TRANSACTION_TYPE,
            ApiType.POST_METHOD,
            encryptedContentData,
            {},
            (data) => {
              if (data !== null) {
                const responseData = data.result.content.map((row) => ({
                          ...row,
                          id: generateRandomId(),
                        }));
                        setOnHoldSummary(responseData);
                        setRowsPerPage(data.result.content.length);
                        setTotalNoOfRows(data.result.totalElements);
                        setTotalNoOfPages(data.result.totalPages);
              }
            }
          );
        });
      } else {
        showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      }
    } catch (error) {
      const message = error.response != null ? error.response : error.message;
      showErrorAlert(
        error.message,
        ERROR_WHILE_FETCHING_DATA + JSON.stringify(message)
      );
    }
    // try {
    //   if (!isNetworkConnectionAvailable) {
    //     throw new Error(NO_INTERNET_CONNECTION_FOUND);
    //   }
    //   setProgressbarText(LOADING_PLEASE_WAIT);
    //   setLoading(true); // Hide the progress dialog

    //   const contentData = {
    //     holdType:holdType,
    //     batchNo: receivedBatchNo,
    //     commissionType: commissionType,
    //     pageNumber: pageNo,
    //     pageSize: pageSize,
    //   };

    //   const encryptedContentData = await initializeEncryption(
    //     contentData,
    //     getFromLocalStorage(MESSAGE_KEY),
    //     ApiType.GET_HOLD_PAYOUT_SUMMARY_TRANSACTION_TYPE
    //   );

    //   const payoutSummaryRequestData = {
    //     requestId: generateRequestId(),
    //     loginId: getFromLocalStorage(LOGIN_ID),
    //     sessionId: getFromLocalStorage(SESSION_ID),
    //     loginUserName: getFromLocalStorage(USER_NAME),
    //     contentData: encryptedContentData,
    //   };

    //   getOnHoldPayoutSummaryTransType(payoutSummaryRequestData)
    //     .then((response) => {
    //       const responseData = response.data.result.content.map((row) => ({
    //         ...row,
    //         id: generateRandomId(),
    //       }));
    //       setOnHoldSummary(responseData);
    //       setRowsPerPage(response.data.result.content.length);
    //       setTotalNoOfRows(response.data.result.totalElements);
    //       setTotalNoOfPages(response.data.result.totalPages);

    //       setLoading(false);
    //       DebugLog(
    //         "getOnHoldPayoutSummaryTransType response.data=====" +
    //           JSON.stringify(response.data)
    //       );
    //     })
    //     .catch((error) => {
    //       handleError(error);
    //     });
    // } catch (error) {
    //   handleError(error);
    // }
  }

  // Create Request Object for API call for table data
  function createRequestObject(holdType, companyCode, batchNo, pageNumber, pageSize, selectedFilter, filterValue) {
    let requestObject = {
      holdType: holdType,
      companyCode: companyCode,
      batchNo: batchNo,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    // Set the appropriate field based on filterCriteria
    if (selectedFilter != null && selectedFilter != undefined && selectedFilter != "" && selectedFilter.paramName != "") {
      if (filterValue != null && filterValue != undefined && filterValue != "") {
        requestObject[selectedFilter] = filterValue;
      }
    }

    // sorting
    try{
      if (sortModel.length > 0) {
        // set sortProperty according to the field
        switch (sortModel[0].field) {
          case "transactionType":
            requestObject.sortProperty = "TRANSACTION_TYPE";
            break;
          case "reportDate":
            requestObject.sortProperty = "REPORT_DATE";
            break;
          case "cutOffDate":
            requestObject.sortProperty = "CUT_OFF";
            break;
          case "payOutDate":
            requestObject.sortProperty = "PAYOUT_BY";
            break;
          default:
            break;
        }

        // set the sort order
        requestObject.sortOrder = sortModel[0].sort.toString().toUpperCase();
      } 
    } catch (error) {
      DebugLog("Error in sorting: " + error);
      requestObject.sortProperty = null;
      requestObject.sortOrder = null;
    }

    return requestObject;
  }

  function blockNavigation(location, action) {
    // Block navigation if action is "pop", which indicates back/forward button press
    if (action === "pop") {
      // Optionally, you can show a message to the user before blocking navigation
      alert("Back button is disabled.");
      return false;
    }
    return true; // Allow navigation for other actions like "push" or "replace"
  }

  // search & filter handler
  const handleSearch = (filterParam, searchQuery) => {
    setSelectedFilter(filterParam);
    setSearchQuery(searchQuery);

    setPaginationModel({ pageSize: pageSize, page: 0 });

    checkSelectedOnHoldCycle();

    // call api with new page size and start from page 0.
    getOnHoldTransactionType(
      selectedOnHoldCycle?.companyCode,
      selectedOnHoldCycle?.holdType,
      selectedOnHoldCycle?.batchNo,
      selectedOnHoldCycle?.commissionType,
      0,
      paginationModel.pageSize,
      filterParam,
      searchQuery
    );
  }

  // handle error code reusable block
  function handleError(error) {
    setLoading(false);

    if (error.message === NO_INTERNET_CONNECTION_FOUND) {
      // Handle no internet connection error
      showErrorAlert(ALERT, NO_INTERNET_CONNECTION_FOUND);
      return;
    }

    const errorCode = error.data?.errorCode;
    var errorMessage =
      error.response != null ? error.displayErrorMessage : "Unknown";
    if (error.data?.displayErrorMessage) {
      errorMessage = error.data.displayErrorMessage;
    }

    const errorActions = {
      [ApiErrorCode.SESSION_EXPIRED]: () => navigate(CONSTANT.LOGIN),
      [ApiErrorCode.SESSION_ID_NOT_FOUND]: () => navigate("/"),
      [ApiErrorCode.UNABLE_TO_PROCESS_ERROR]: () =>
        navigate(CONSTANT.FINANCE_DASHBOARD),
      default: () =>
        showErrorAlert(
          error.message,
          ERROR_WHILE_FETCHING_DATA + JSON.stringify(errorMessage)
        ),
    };

    (errorActions[errorCode] || errorActions.default)();
  }

  function showErrorAlert(title, content) {
    try {
      DebugLog("an error found====" + content);
      setError();
      setLoading(false);

      setTitle(title);
      setContent(content);
      setErrorDialog(true);
    } catch (error) {
      DebugLog(error);
    }
  }

  const showNoInternetSnackBar = () => {
    if (isNetworkConnectionAvailable) {
      enqueueSnackbar(YOU_ARE_ONLINE);
    } else {
      enqueueSnackbar(YOU_ARE_OFFLINE, {
        autoHideDuration: 3000,
        variant: "error",
      });
    }
  };

  /***** Navigation *******/
  const handleBackClicked = () => {
    checkSelectedOnHoldCycle();
    if (selectedOnHoldCycle.flowFrom === CONSTANT.ON_HOLD_ROUTE) {
      navigate(CONSTANT.ON_HOLD_ROUTE);
    } else {
      navigate(CONSTANT.FINANCE_DASHBOARD);
    }
  };

  const handleRowClick = (params) => {
    checkSelectedOnHoldCycle();
    // {
    //     "payoutCycle": "Weekly : 8th - 14th",
    //     "companyCode": "A0002",
    //     "pageNumber": 0,
    //     "endDate": "2023-07-31",
    //     "pageSize": 100,
    //     "payoutStatus": "Hold",
    //     "startDate": "2023-07-01",
    //     "payoutDate": "2023-07-28"
    // }

    const pageNumber = 0;
    const pageSize = 20;
    const onHoldAllTransactionsRowSelected = {
      transactionType: params.row.transactionType,
      companyCode: params.row.companyCode,
      startDate: params.row.startDate,
      endDate: params.row.endDate,
      payoutStatus: params.row.payoutStatus,
      payoutDate: params.row.payOutDate,
      payoutCycle: params.row.payoutCycle,
      pageNumber: pageNumber,
      pageSize: pageSize,
    };

    // DebugLog(
    //   "onHoldALl Transaction RowSelected  " +
    //     JSON.stringify(onHoldAllTransactionsRowSelected)
    // );
    // saveToLocalStorageJsonObject(
    //   NAV_ONHOLD_ALL_TRANSACTIONS,
    //   onHoldAllTransactionsRowSelected
    // );
    navigate(CONSTANT.ON_HOLD_DEALERS_ROUTE, {
      state: {
        holdType:selectedOnHoldCycle.holdType,
        companyName: selectedOnHoldCycle.companyName,
        companyCode:selectedOnHoldCycle.companyCode,
        batchNo: params.row.batchNo,
        commissionType: selectedOnHoldCycle.commissionType,
        transactionType: params.row.transactionType,
        displayName: selectedOnHoldCycle.displayName,

        // showApproval: selectedOnHoldCycle?.showApproval,
        // showCancel: selectedOnHoldCycle?.showCancel,
        // showHold: selectedOnHoldCycle?.showHold,
        // showRelease: selectedOnHoldCycle?.showRelease,
        // showRequestApproval: selectedOnHoldCycle?.showRequestApproval,
        // showRequestRelease: selectedOnHoldCycle?.showRequestRelease,
      },
    });
  };

  return (
    /* Main Container */
    <Box>
      <SnackbarProvider maxSnack={3}>
        <ConnectionStatus />
        <ShowErrorAlertDialog
          status={getDialogStatus}
          title={title}
          content={content}
        />

        {isNetworkConnectionAvailable ? (
          <CustomProgressDialog open={loading} text={getProgressbarText} />
        ) : (
          showNoInternetSnackBar()
        )}
        <Grid
          container
          component="main"
          direction={"column"}
          sx={{
            // height: "100vh",
            m: "0 2.5%" /* Approx 30px */,
            borderRadius: "18px",
          }}
        >
          {/* Header */}
          <Grid container direction={"row"} alignItems={"center"} mb={2} ml={2}>
            <Grid item mr={2}>
              <IconButton onClick={handleBackClicked} width={12}>
                <img src={"../../assets/common/Back.svg"} width={12} />
              </IconButton>
            </Grid>
            <Grid item>
              <Typography
                color={colors.grey[100]}
                fontWeight={"600"}
                variant="h3"
              >
                {payoutCycleName}
              </Typography>
            </Grid>
          </Grid>
          {/* Header */}
          {/* Highlight Stats */}
          <HighlightStats
            highlightTotal={
              "RM " + formatPrice(onHoldHeaderSummary.totalAmount)
            }
            highlight1={"Device Reimbursement"}
            highlight1Stat={
              "RM " + formatPrice(onHoldHeaderSummary.deviceAmount)
            }
            highlight2={"Incentives"}
            highlight2Stat={
              "RM " + formatPrice(onHoldHeaderSummary.incentiveAmount)
            }
          ></HighlightStats>
          {/* Highlight Stats */}

          {/* On Hold Section */}
          <Grid
            container
            mt={3}
            border={"1px solid" + colors.grey[600]}
            borderRadius={3}
            xs={12}
            sm={12}
            md={12}
            lg={12}
            xl={12}
            pb={2}
          >
            {/* <SectionHeader
              sectionIcon={"../../assets/common/onhold.svg"}
              sectionHeading={"On Hold"}
            ></SectionHeader> */}

            {onHoldSummary.length > 0 ? (
              <Box
                borderRadius={3}
                flex={1}
                m="0px 0 0 0"
                pb={0}
                height={gridHeight}
                sx={{
                  "& .MuiDataGrid-root": {
                    border: "none",
                  },
                  "& .MuiDataGrid-cell": {
                    borderBottom: "none",
                  },
                  "& .name-column--cell": {
                    color: colors.redAccent[200],
                    fontWeight: "bold",
                    fontSize: 13,
                  },
                  "& .MuiDataGrid-columnHeaders": {
                    backgroundColor: "rgba(255,255,255,0.6)",
                    borderBottom: "none",
                    fontWeight: "bold",
                    fontSize: "13px",
                    color: `${colors.grey[300]} !important`,
                  },
                  "& .MuiDataGrid-virtualScroller": {
                    background: "rgba(255,255,255,1)",
                  },
                  "& .MuiDataGrid-footerContainer": {
                    borderTop: "none",
                    backgroundColor: "rgba(255,255,255,0.6)",
                  },
                  "& .MuiCheckbox-root": {
                    //color: `${colors.white[200]} !important`,
                  },
                  "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                    color: `${colors.grey[300]} !important`,
                    // backgroundColor: "rgba(255,255,255,0.6)",
                    // opacity:.5
                  },
                }}
              >
                <DataGrid
                  classes={{ row: "dataGridRow" }}
                  rows={onHoldSummary}
                  columns={onHoldPayoutCycleColumnHeader}
                  checkboxSelection
                  selectionModel={selectedRows}
                  onSelectionModelChange={handleSelectionChange}
                  pageSize={pageSize}
                  rowCount={totalNoOfRows}
                  paginationModel={paginationModel}
                  paginationMode="server"
                  keepNonExistentRowsSelected
                  disableSelectionOnClick // Disable row selection on row click
                  onPageChange={handlePageChange}
                  onPageSizeChange={handlePageSizeChange}
                  rowsPerPageOptions={[15, 30, 45, 60]}
                  autoHeight
                  onRowClick={handleRowClick}


                  sortModel={sortModel}
                  onSortModelChange={(newSortModel) => setSortModel(newSortModel)}
                />
              </Box>
            ) : (
              NoDataFound()
            )}
          </Grid>

          {onHoldSummary.length > 0 ? (
            <Box item mt={6}>
              <Typography>
                <span>Jump to page: </span>
                <select
                  value={paginationModel.page + 1}
                  onChange={handlePageJump}
                >
                  {[...Array(totalNoOfPages)].map((_, index) => (
                    <option key={index} value={index + 1}>
                      {index + 1}
                    </option>
                  ))}
                </select>
              </Typography>
            </Box>
          ) : (
            ""
          )}

          {/* Confirmation Dialog */}
        <IncentivesActionsConfirmationDialog
            open={dialogOpen}
            handleClose={handleDialogClose}
            handleSubmit={handleSubmit}
            type={clickedButtonType}
            title={dialogTitle}
          />
        {/* Confirmation Dialog */}
 
          {/* <FileDialog
            open={dialogOpen}
            handleClose={handleDialogClose}
            handleSubmit={handleSubmit}
            type={clickedButtonType}
            title={dialogTitle}
          /> */}

          {/* On Hold Section */}

          {/* Action Buttons */}

          {onHoldSummary.length > 0 ? (
            <Grid item mt={1} justifyContent={"flex-start"} pb={10}>
              <Stack direction="row" spacing={2} justifyContent={"flex-end"}>

                {requestReleaseButtonVisible ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    // btnStartIcon={
                    //   <img src="../../assets/common/Cross.svg" width={22} />
                    // }
                    btnTxt={"Request Release"}
                    onClick={() => handleDialogOpen("Request Release")}
                  ></CustomButton>
                ) : (
                  ""
                )}
                {cancelButtonButtonVisibility ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Cross.svg" width={22} />
                    }
                    btnTxt={"Cancel"}
                    onClick={() => handleDialogOpen("Cancel")}
                  ></CustomButton>
                ) : (
                  ""
                )}
              {rejectButtonVisibility  ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Tick.svg" width={22} />
                    }
                    btnTxt={"Reject"}
                    onClick={() => handleDialogOpen("Reject")}
                  ></CustomButton>
                ) : (
                  ""
                )}
                {releaseButtonVisibility ? (
                  <CustomButton
                    btnBG={colors.grey[900]}
                    btnColor={colors.grey[100]}
                    btnStartIcon={
                      <img src="../../assets/common/Tick.svg" width={22} />
                    }
                    btnTxt={"Release"}
                    onClick={() => handleDialogOpen("Release")}
                  ></CustomButton>
                ) : (
                  ""
                )}

                {downloadButtonVisible ? (
                  <DownloadDropdownButton
                    onFileTypeSelected={downloadOnHoldDetails}
                  />
                ) : (
                  ""
                )}
              </Stack>
            </Grid>
          ) : (
            ""
          )}
          {/* Action Buttons */}
        </Grid>
      </SnackbarProvider>
    </Box>
    /* Main Container */
  );
}
